import { Clock, Sparkles, ExternalLink } from "lucide-react";

const activities = [
  {
    name: "Kite surf, wind surf & E-foil lessons",
    img: "https://images.unsplash.com/photo-1502933691298-84fc14542831?auto=format&fit=crop&w=1200&q=85",
    time: "Half day",
    planned: false,
    note: "Cabarete is world-famous for it. Beginner-friendly. Lessons through Villa Taina Water Club.",
    link: "https://villatainawaterclub.com/",
  },
  {
    name: "27 Charcos waterfalls",
    img: "https://images.unsplash.com/photo-1752995414113-c24537719387?auto=format&fit=crop&w=900&q=80",
    time: "Half day",
    planned: false,
    note: "Canyoning day trip — jump and slide down 27 waterfalls. Bring water shoes.",
    link: "https://27waterfalls.org/",
  },
  {
    name: "Horseback riding in the mountains",
    img: "https://images.unsplash.com/photo-1553284965-83fd3e82fa5a?auto=format&fit=crop&w=1200&q=85",
    time: "Half day",
    planned: false,
    note: "Ride through the Cabarete mountains and rainforest. Easy pace, great views.",
    link: "https://www.getyourguide.com/sosua-l129503/horseback-riding-through-the-mountains-in-cabarete-t1108546/",
  },
  {
    name: "Encuentro surf lesson",
    img: "https://images.unsplash.com/photo-1502680390469-be75c86b636f?auto=format&fit=crop&w=900&q=80",
    time: "2 hours",
    planned: false,
    note: "Sunrise sessions are magical. Beginner-friendly waves at Encuentro Beach.",
    link: "https://www.viator.com/tours/Dominican-Republic/Learn-to-Surf/d32-269142P1",
  },
  {
    name: "Snorkel & scuba diving",
    img: "https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&w=1200&q=85",
    time: "Half day",
    planned: false,
    note: "Calm bays, great viz, good for all levels. Certified dives or intro lessons.",
    link: "https://www.divecabarete.com/",
  },
  {
    name: "Sunrise beach yoga",
    img: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=900&q=80",
    time: "1 hour",
    planned: false,
    note: "Drop-in on the beach. Schedule and details from KH Cabarete.",
    link: "https://www.khcabarete.com/post/yoga-in-cabarete",
  },
  {
    name: "Playa Grande beach day",
    img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=900&q=80",
    time: "Half day",
    planned: false,
    note: "One of the DR's most beautiful beaches. Day passes, food, and chairs at the Beach Club.",
    link: "https://www.playagrandebeachclub.com/amenities-activities",
  },
];

export default function ThingsToDo() {
  return (
    <div className="bg-cream">
      <section className="pt-20 pb-10 md:pt-28 md:pb-14" data-testid="do-hero">
        <div className="max-w-6xl mx-auto px-6 md:px-10">
          <p className="text-xs tracking-[0.4em] uppercase text-terracotta font-medium mb-4">Between beach naps</p>
          <h1 className="font-display text-6xl md:text-8xl font-black text-ink leading-[0.9]">
            Things to <span className="italic text-sage-dark">do.</span>
          </h1>
          <p className="text-lg text-muted_ink mt-5 max-w-2xl">
            Cabarete has it all: world-class kite-surfing, waterfalls you hike and slide down, sunrise yoga on the sand, quiet surf breaks, and catamarans at sunset. There's honestly more than you can fit in a long weekend, so stay a few extra days if you can. Official group outings are TBD.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16">
        <div className="max-w-6xl mx-auto px-6 md:px-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {activities.map((a, i) => {
            const Card = a.link ? "a" : "div";
            const linkProps = a.link ? { href: a.link, target: "_blank", rel: "noreferrer" } : {};
            return (
              <Card
                key={a.name}
                {...linkProps}
                className={`bg-sand border border-shell rounded-lg overflow-hidden group block ${a.link ? "hover:-translate-y-1 transition-transform duration-300" : ""}`}
                data-testid={`activity-${i}`}
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={a.img} alt={a.name} className="w-full h-full object-cover vintage-filter group-hover:scale-105 transition-transform duration-700" />
                  {a.planned && (
                    <span className="absolute top-3 left-3 bg-terracotta text-cream text-xs tracking-wider uppercase rounded-full px-3 py-1 font-medium flex items-center gap-1">
                      <Sparkles className="w-3 h-3" /> Group outing
                    </span>
                  )}
                </div>
                <div className="p-5">
                  <div className="flex items-baseline justify-between gap-3">
                    <h3 className="font-display text-2xl font-black text-ink leading-tight">{a.name}</h3>
                    {a.link && <ExternalLink className="w-4 h-4 text-muted_ink group-hover:text-terracotta transition-colors flex-shrink-0" />}
                  </div>
                  <p className="text-sm text-muted_ink mt-2 mb-4">{a.note}</p>
                  <div className="flex items-center text-sm pt-4 border-t border-shell">
                    <span className="flex items-center gap-1 text-ink"><Clock className="w-3.5 h-3.5 text-sage-dark" /> {a.time}</span>
                  </div>
                </div>
              </Card>
            );
          })}
        </div>
      </section>
    </div>
  );
}
